import CropperImage from './src/main'

export default CropperImage



// WEBPACK FOOTER //
// ./src/views/question-review/components/CropperImage/index.js